/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'pin': {
    width: 16,
    height: 20,
    viewBox: '0 0 16 20',
    data: `<path pid="0" d="M8 20S0 12.418 0 8a8 8 0 0 1 16 0c0 4.418-8 12-8 12zm0-8a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"/>`
  }
})
